import { Grid, Stack, Skeleton, Avatar, Typography, Box } from '@mui/material'
import React from 'react'

const MAX_COLUMN = 9
const MAX_LINE = 5

const WIDTH_ELEMENT = '100%'

function renderColumns() {
  const array = []
  for (let index = 0; index < MAX_COLUMN; index += 1) {
    array.push(index)
  }

  return array.map((item) => {
    const key = `column-${item}`
    return (
      <Stack
        key={key}
        flexDirection="row"
        gap="0.4rem"
        width={WIDTH_ELEMENT}
        alignItems="center"
        justifyContent="flex-start"
      >
        <Skeleton variant="circular" width="0.8rem" height="0.8rem">
          <Avatar />
        </Skeleton>
        <Skeleton width="100%">
          <Typography>.</Typography>
        </Skeleton>
      </Stack>
    )
  })
}

function renderCels() {
  const array = []
  for (let index = 0; index < MAX_COLUMN; index += 1) {
    array.push(index)
  }
  return array.map((item) => {
    const key = `line-${item}`
    return (
      <Stack
        key={key}
        flexDirection="row"
        gap="0.5rem"
        width={WIDTH_ELEMENT}
        alignItems="center"
        justifyContent="center"
      >
        <Skeleton variant="rectangular" height="1rem" width="100%">
          <Typography>.</Typography>
        </Skeleton>
      </Stack>
    )
  })
}

function renderLines() {
  const array = []
  for (let index = 0; index < MAX_LINE; index += 1) {
    array.push(index)
  }

  return array.map((item) => {
    const key = `line-${item}`
    return (
      <Box
        key={key}
        display="flex"
        flexDirection="row"
        borderBottom={2}
        borderColor="divider"
        gap="0.5rem"
        height="2rem"
        flexWrap="nowrap"
      >
        {renderCels()}
      </Box>
    )
  })
}

function DefaultTableSkeleton() {
  return (
    <Stack component="div" flexDirection="column">
      <Stack
        id="skeleton-conversion-report-table-container"
        data-testid="skeleton-conversion-report-table-container"
        border={1}
        borderColor="#DDD"
        padding={1}
      >
        <Stack flexDirection="row" gap="1rem">
          <Grid container height="3rem" width="30%">
            <Skeleton height="100%" width="100%" />
          </Grid>
        </Stack>
        <Stack
          id="skeleton-conversion-report-table"
          data-testid="skeleton-conversion-report-table"
          flexDirection="column"
          gap="1rem"
          padding={2}
        >
          <Box
            display="flex"
            flexDirection="row"
            borderBottom={2}
            borderColor="#00AEEF"
            mt="1rem"
            gap="0.5rem"
            flexWrap="nowrap"
          >
            {renderColumns()}
          </Box>
          {renderLines()}
        </Stack>
        <Stack flexDirection="row" alignItems="center" justifyContent="flex-end" padding={2} gap="1rem">
          <Stack gap="0.5rem">
            <Skeleton variant="rectangular" height="1rem" width="10rem">
              <Typography>.</Typography>
            </Skeleton>
          </Stack>
          <Stack gap="0.5rem">
            <Skeleton variant="rectangular" height="1rem" width="5rem">
              <Typography>.</Typography>
            </Skeleton>
          </Stack>
          <Stack gap="0.5rem">
            <Skeleton variant="rectangular" height="1rem" width="5rem">
              <Typography>.</Typography>
            </Skeleton>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default DefaultTableSkeleton
